import { LanguageEnum } from '@Modules/app/constants';

export const OgLocale = {
  [LanguageEnum.RU]: 'ru_UZ',
  [LanguageEnum.UZ]: 'uz_UZ',
};
